/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
import React, { useCallback } from 'react'
import { IcoMoon, PlusIcon } from '@usap/uicomponents'

import { StyledShopInfoHeader, StyledShopInfoSection, StyledShopMessage } from './InstallAtShopNoVehicle.css'
import Button from '../Button/Button'
import { ButtonSize, ButtonVariant } from '../Button/Button.config'
import useWmoEnabled from '../../../hooks/useWmoEnabled'
import InstallAtShopNoVehicleCartWmo from './InstallAtShopNoVehicleWmo'
import { ICartItemProduct } from '../models/ICart'

export interface IInstallAtShopInfo {
  showBorder?: boolean
  showTopDivider?: boolean
  addVehicleTrigger: () => void
  page?: 'Cart',
  product?: ICartItemProduct
}

const InstallAtShopNoVehicle: React.FC<IInstallAtShopInfo> = ({
  showBorder = true, addVehicleTrigger, showTopDivider = false, page, product,
}) => {
  const isWmoEnabled = useWmoEnabled()
  const onAddVehicle = useCallback(
    () => {
      addVehicleTrigger()
    },
    [addVehicleTrigger],
  )

  if (isWmoEnabled && page === 'Cart') {
    return <InstallAtShopNoVehicleCartWmo product={product} />
  }

  return (
    <StyledShopInfoSection showBorder={showBorder} showTopDivider={showTopDivider} data-testid="install-at-shop-no-vehicle">
      <StyledShopInfoHeader>
        Install at Shop
      </StyledShopInfoHeader>

      <StyledShopMessage>
        Tell us what you drive and one of our certified shops can get it done for you.
      </StyledShopMessage>

      <Button
        variant={ButtonVariant.Border}
        size={ButtonSize.Small}
        width="310px"
        label="Add Vehicle"
        Icon={<IcoMoon icon={PlusIcon} viewBoxProp="0 0 24 24" size="24px" />}
        data-testid="add-vehicle-cta"
        onClick={onAddVehicle}
      />

    </StyledShopInfoSection>
  )
}

export default React.memo(InstallAtShopNoVehicle)
